const state = {
  status: []
}
const mutations = {
  status(state, status) {
    state.status = status;
  }

}
const actions = {
  setStatus({
    commit
  }, status) {
    commit('status', status)

  },

}
const getters = {
  status: state => {
    console.log(state.status);
    return state.status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}